import { React, useEffect, useState } from "react";
import Sidebarmenu from "../../SideMenu/Sidemenu";
import TopHeader from "../../TopHeader/TopHeader";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./Calender.css";
import Modal from "react-modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import backimg from "../../../../img/back.svg";
import back from "../../../../img/back.svg";
// import "react-datetime/css/react-datetime.css";
import {
  Calendar,
  momentLocalizer,
  dateFnsLocalizer,
} from "react-big-calendar";
import { Toolbar } from "react-big-calendar";
import moment from "moment";
import Offcanvas from "react-bootstrap/Offcanvas";
// import { calendercreact } from "../../../../Helper/Redux/slice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  userView,
  getCountries,
  getbranch,
  Appointmentbook,
  ViewBookAppointment,
  RemoveAppointment,
  appointmentReferralOption,
  appointmenttimeslots,
  appointmenthearOption,
} from "../../../../Helper/Redux/API";
import Select from "react-select";
const localizer = momentLocalizer(moment);

function CustomEvent({ event }) {
  const currentDate = moment().startOf("day");
  const previousDate = moment(event?.start).startOf("day");
  const isTodayOrFuture = moment(previousDate).isSameOrAfter(
    currentDate,
    "day"
  );

  // console.log(event, "event");
  // const eventlist =event.map((scheduleTypedata) => scheduleTypedata?.scheduleType );

  return (
    <>
      <div>
        {/* <div className="Menu_test">Menu</div> */}
        <div className="bg_event" style={{ backgroundColor: event.colorcode }}>
          <p className="mb-0 branch_text">
            Branch : <span>{event.title ? event.title : ""}</span>
          </p>
          <p className="mb-0">Time : {event.timezone ? event.timezone : ""}</p>
        </div>
        {/* <div className="d-none show_btn">View More</div> */}
        {/* <button className='Event_btn'>view More</button> */}
      </div>
    </>
  );
}

function CalendarPage(props) {
  var token = localStorage.getItem("access_token");
  const dispatch = useDispatch();
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  // hooks
  const [showview, setShowview] = useState(false);
  const [showview2, setShowview2] = useState(false);
  const [date, setDate] = useState("");
  const [eventview, setEventView] = useState("");
  const [addmenuopen, setAddMenuOpen] = useState(false);
  const [creactdate, setCreactDate] = useState("");
  const [selectcenter, setSelectCenter] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [gandar, setGander] = useState("");
  const [dob, setDOB] = useState("");
  const [address, setAddress] = useState("");
  const [occupation, setOccupation] = useState("");
  const [languagesspoken, setLanguagesSpoken] = useState("");
  const [nationality, setNationality] = useState("");
  const [mobilenumber, setMobileNumber] = useState("");
  const [officenumber, setOfficeNumber] = useState("");
  const [Homenumber, setHomeNumber] = useState("");
  const [address2, setAddress2] = useState("");
  const [Postalcode, setPostalcode] = useState("");
  const [nricnumber, setNRICNumber] = useState("");
  const [racenumber, setRaceNumber] = useState("");
  const [selecttime, setSelectTime] = useState("");
  const [selectreferral, setSelectReferral] = useState("1");
  const [selecthearing, setSelectHearing] = useState("1");
  const [allCountries, setAllCoountries] = useState("");
  const [allCenter, setAllCenter] = useState("");
  const [Familyname, setFamilyName] = useState("");
  const [Familynumber, setFamilyNumber] = useState("");
  const [Familynumberhp, setFamilyNumberHp] = useState("");
  const [relationshiptopatient, setRelationShiptoPatient] = useState("");
  const [timeslot, setTimeslot] = useState([]);
  // For Office USE
  const [selectstate, setSelectState] = useState("");
  const [onset, setOnSet] = useState("");
  const [onsetl, setOnSetL] = useState("");
  const [onsetR, setOnSetR] = useState("");
  const [birth, setBirth] = useState("");
  const [Gradual, setGradual] = useState("");
  const [Student, setStudent] = useState("");
  const [otherphasestate, setOtherPhaseState] = useState("");
  const [earpain, setEarPain] = useState("");
  const [headinjury, setHeadInjury] = useState("");
  const [medicalcondition, setMedicalCondition] = useState("");
  const [discharge, setDischarge] = useState("");
  const [surgery, setSurgery] = useState("");
  const [currentmedication, setCurrentMedication] = useState("");
  const [headache, setHeadache] = useState("");
  const [nosieexposure, setNosieExposure] = useState("");
  const [sinusitus, setSinusitus] = useState("");
  const [painswallowing, setPainSwallowing] = useState("");
  const [familyhistory, setFamilyHistory] = useState("");
  const [vertigo, setVertigo] = useState("");
  const [fullnessofear, setFullnessOfEar] = useState("");
  const [tinnitus, setTinnitus] = useState("");
  const [vomiting, setVomiting] = useState("");
  const [removebook, setRemoveBook] = useState("");
  // Area of Difficulty

  const [onetoone, setOneToOne] = useState("");
  const [meeting, setMeeting] = useState("");
  const [television, setTelevision] = useState("");
  const [backgroundnoise, setBackgroundNoise] = useState("");
  const [group, setGroup] = useState("");
  const [church, setChurch] = useState("");
  const [telephone, setTelephone] = useState("");
  const [other, setOther] = useState("");
  const [remarks, setRemarks] = useState("");
  const [getappointment, setGetAppointment] = useState([]);
  const history = useNavigate();
  const getcenterData = () => {
    dispatch(getbranch()).then((res) => {
      if (res?.payload?.status === true) {
        setAllCenter(res?.payload?.data);
        // console.log(res?.payload?.data);
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };

  const hearingcenter = Array.isArray(allCenter)
    ? allCenter.map((item) => ({
        label: item.title,
        value: item.id,
      }))
    : [];

  const getcountriData = () => {
    dispatch(getCountries()).then((res) => {
      if (res?.payload?.status === true) {
        setAllCoountries(res?.payload?.data);
        // console.log(res?.payload?.data);
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };

  const Countries = Array.isArray(allCountries)
    ? allCountries.map((item) => ({
        label: item.title,
        value: item.id,
      }))
    : [];

  const getAppointmentData = () => {
    const userid = {
      user_id: localStorage.getItem("id"),
    };
    dispatch(ViewBookAppointment(userid)).then((res) => {
      if (res?.payload?.status === true) {
        setGetAppointment(res?.payload?.data);
        // console.log(res?.payload?.data, "ffssssssss");
      } else {
        // console.log(res, "ssm,ss");
        setGetAppointment("");
      }
    });
  };

  // console.log("allCountries", Countries);

  useEffect(() => {
    getcountriData();
    getcenterData();
  }, []);

  const components = {
    event: CustomEvent,
  };

  const eventStyleGetter = (event, start, end, isSelected) => {
    const backgroundColor = event.color || "#F7A3B2";
    const style = {
      backgroundColor,
      borderRadius: "3px",
      opacity: isSelected ? 1 : 1,
      color: "#fff",
      border: "none",
      display: "block",
    };
    return { style };
  };

  const events4 = Array.isArray(getappointment)
    ? getappointment.map((item, i) => {
        const dateOnly = item.start_date_time.split(" ")[0];
        const timechange = moment(dateOnly).format("DD/MM/YYYY");
        const startDate = moment(timechange, "DD/MM/YYYY").toDate(); // Parse date with format
        const endDate = moment(startDate).endOf("day").hour(15).toDate();
        // console.log("item", item);
        return {
          start: new Date(startDate),
          end: endDate,
          title: item.branch_name,
          timezone: item.time,
          id: item.id,
          audiologistname: item.audiologist_name,
          branchaddress: item.branch_address,
          colorcode: item.color,
          appointmentnumber: item.appointment_number,
          purposeOfVisit: item.purposeOfVisit,
        };
      })
    : [];

  const [previousDate, setPreviousDate] = useState(null);
  const handleEventCreate = ({ slotInfo, start, events }) => {
    // setSelectedSlot(slotInfo);
    // setSelectedDate(start);
    const existingEvent = events4.filter((event) =>
      moment(event.start).isSame(start, "day")
    );
    // console.log("existingEvent2", existingEvent);
    if (existingEvent.length > 0) {
      // setShowPopup(false);
      setShowview(true);
      // console.log("existingEvent", existingEvent);
      setEventView(existingEvent ? existingEvent : "");
      setAddMenuOpen(false);
    } else {
      const newEvent = {
        title: "",
        start: start,
        end: moment(start).add(1, "hour"), // Adjust the end time as needed
      };

      // Perform any additional actions for new event creation if needed
      // console.log("New Event Created:", newEvent.start);
      // setAddMenuOpen(true);
      // Perform actions for no existing event
      // setShowPopup(true);
      setCreactDate(newEvent.start);

      const data = {
        date: moment(newEvent.start).format("YYYY-MM-DD"),
      };

      const creactdate = moment(newEvent.start, "DD/MM/YYYY");
      const currentDate = moment();
      if (currentDate.isSame(creactdate, "day")) {
        // console.log(
        //   `Current date1 ${currentDate.format(
        //     "DD/MM/YYYY"
        //   )} is the same as ${creactdate.format("DD/MM/YYYY")}`
        // );
        setAddMenuOpen(true); // Do not open the popup for today's date
      } else if (currentDate.isAfter(creactdate, "day")) {
        // console.log(
        //   `Current date2 ${currentDate.format(
        //     "DD/MM/YYYY"
        //   )} is after ${creactdate.format("DD/MM/YYYY")}`
        // );
        setAddMenuOpen(false); // Open the popup for dates after creactdate
      } else {
        // console.log(
        //   `Current date3 ${currentDate.format(
        //     "DD/MM/YYYY"
        //   )} is before ${creactdate.format("DD/MM/YYYY")}`
        // );

        const currentDay = new Date(creactdate).getDay();
        // Open the popup for dates before creactdate

        if (currentDay == 0) {
          alert("Sunday is the holiday of hearing center.");
          setAddMenuOpen(false);
        } else {
          setAddMenuOpen(true);
          // console.log(" console.log('dddd',currentDay);", currentDay);
        }

        // console.log("currentDay", currentDay);
      }

      // setAddMenuOpen(true);

      getviewuser();
      try {
        dispatch(appointmenttimeslots(data)).then((res) => {
          if (res?.payload?.status === true) {
            setTimeslot(res?.payload?.data);
          } else {
            setTimeslot([]);
          }
        });
      } catch (error) {
        console.log(error, "error");
      }
    }
  };

  const formats = {
    eventTimeRangeFormat: () => {
      return "";
    },
  };
  // console.log("events4", events4);

  const closeViewPopup = () => {
    // setSelectedEvent(null);
    setShowview(false);
  };

  const closeViewPopup2 = () => {
    // setSelectedEvent(null);
    setShowview2(false);
    setShowview(true);
  };

  // const handleToggle = () => {
  //   setAddMenuOpen(true);
  // };

  const handleClose = () => {
    setAddMenuOpen(false);
    setSelectTime();
    setSelectCenter('')
  };

  // const Calenderviewdata = () => {
  //   const data = {

  //   };

  //   dispatch(calendercreact(data)).then((res) => {
  //     if (res?.payload?.status === true) {
  //     } else {
  //       toast.error(res?.payload?.message);
  //     }
  //   });
  // };

  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("UserName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("step2");
    localStorage.removeItem("step3");
    localStorage.removeItem("step4");
    localStorage.removeItem("step5");
    localStorage.removeItem("step6");
    localStorage.removeItem("step7");
    localStorage.removeItem("step8");
    localStorage.removeItem("step9");
    localStorage.removeItem("Rightear2KHz");
    localStorage.removeItem("Rightear4KHz");
    localStorage.removeItem("Leftear1KHz");
    localStorage.removeItem("Leftear6KHz");
    localStorage.removeItem("Measuretest");
    localStorage.removeItem("Roleid");
    localStorage.removeItem("id");
    localStorage.removeItem("result_test_id");
    localStorage.removeItem("Rightear500Hz");
    localStorage.removeItem("rightear1KHz");
    localStorage.removeItem("Leftear500Hz");
    localStorage.removeItem("Leftear2000KHz");
    localStorage.removeItem("UserName");
    localStorage.removeItem("LastName");
    // localStorage.removeItem("testtrue");
    history("/");
  };

  const getviewuser = () => {
    const data = {
      id: localStorage.getItem("id"),
    };

    try {
      dispatch(userView(data)).then((res) => {
        if (res?.payload?.status === true) {
          setFirstName(res?.payload?.data.first_name);
          setLastName(res?.payload?.data.last_name);
          // const datetimeString = res?.payload?.data.dob;
          // const dateOnly = datetimeString.split(" ")[0];
          // setDOB(dateOnly);

          const datetimeString = res?.payload?.data.dob;
          if (datetimeString) {
            const splitDatetime = datetimeString.split(" ");
            if (splitDatetime.length > 0) {
              const dateOnly = splitDatetime[0];
              setDOB(dateOnly);
              console.log(dateOnly);
            } else {
              console.error(
                "Datetime string is not in the expected format:",
                datetimeString
              );
            }
          } else if (res?.payload?.status == false) {
            console.log("res?.payload?.status");
          } else {
            console.log("res?.payload?.status", res);
            console.error("Datetime string is null or undefined.");
          }
          // console.log(res?.payload?.data);
          setEmail(res?.payload?.data.email);
          // setSelectCenter(
          //   hearingcenter.length > 0 ? hearingcenter[0].value : ""
          // );
          setMobileNumber(res?.payload?.data?.mob_number);
          setAddress(res?.payload?.data?.address_one);
          setAddress2(res?.payload?.data?.address_two);
          setPostalcode(res?.payload?.data?.postal_code);
          // setRaceNumber(res?.payload?.data?.race_number);
          setNRICNumber(res?.payload?.data?.nric_number);
          setNationality(res?.payload?.data?.country_id);
          setGander(res?.payload?.data.gender);
          setHomeNumber(res?.payload?.data?.home_number);
          // setLanguagesSpoken(res?.payload?.data?.contact_lang);
          // setFamilyName(res?.payload?.data?.family_member_name);
          setFamilyNumberHp(res?.payload?.data?.family_member_hp);
          setOnSet(res?.payload?.data?.onset);
          setOnSetR(res?.payload?.data?.right);
          setOnSetL(res?.payload?.data?.left);
          setGradual(res?.payload?.data?.gradual);
          setStudent(res?.payload?.data?.student);
          setBirth(res?.payload?.data?.birth);
          setOtherPhaseState(res?.payload?.data?.other_phase_state);
          setEarPain(res?.payload?.data?.ear_pain);
          setHeadInjury(res?.payload?.data?.head_injury);
          setMedicalCondition(res?.payload?.data?.medical_condition);
          setDischarge(res?.payload?.data?.discharge);
          setSurgery(res?.payload?.data?.surgery);
          setCurrentMedication(res?.payload?.data?.current_medication);
          setHeadache(res?.payload?.data?.headache);
          setVomiting(res?.payload?.data?.vomating);
          setNosieExposure(res?.payload?.data?.noise_exposure);
          setSinusitus(res?.payload?.data?.sinusitus);
          setPainSwallowing(res?.payload?.data?.pain_swallowing);
          setFamilyHistory(res?.payload?.data?.family_history);
          setVertigo(res?.payload?.data?.vertigo);
          setFullnessOfEar(res?.payload?.data?.fullness_of_ear);
          setTinnitus(res?.payload?.data?.tinnitus);
          setOneToOne(res?.payload?.data?.one_to_one);
          setMeeting(res?.payload?.data?.meeting);
          setTelevision(res?.payload?.data?.television);
          setBackgroundNoise(res?.payload?.data?.background_noise);
          setGroup(res?.payload?.data?.group);
          setChurch(res?.payload?.data?.church);
          setTelephone(res?.payload?.data?.telephone);
          setOther(res?.payload?.data?.other);
          setRemarks(res?.payload?.data?.remarks);
        }

        if (res?.payload?.is_active == false) {
          console.log("res?.payload?.status");
          logout();
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getviewuser();
  }, []);

  const handleChangegender = (event) => {
    setGander(event.target.value); // Update the state with the selected value
  };

  const handleChangenationality = (event) => {
    setNationality(event.target.value); // Update the state with the selected value
  };

  const handleChangecenter = (event) => {
    setSelectCenter(event.target.value); // Update the state with the selected value
  };

  const handleChangestate = (event) => {
    setSelectState(event.target.value); // Update the state with the selected value
  };

  const handleReferral = (event) => {
    setSelectReferral(event.target.value); // Update the state with the selected value
  };

  const handleadjustment = (event) => {
    setSelectHearing(event.target.value); // Update the state with the selected value
  };
  const handledate = (e) => {
    setDOB(e.target.value); // Update the state with the selected date
  };

  const handleChangetime = (event) => {
    setSelectTime(event.target.value);
    console.log("fff", event.target.value, event);
    // console.log("event.target.value", event.target.value); // Update the state with the selected value
  };
  const [errorMessage , setErrorMessage] = useState(false)
  const handleSubmit = (e) => {
    e.preventDefault();
    if( !selectcenter){
        setErrorMessage(true)
        toast.error("Please check the required field ")
    }
    else {
    const data = {
      branch_id: selectcenter,
      patient_id: localStorage.getItem("id"),
      start_date_time: moment(creactdate).format("YYYY-MM-DD"),
      end_date_time: moment(creactdate).format("YYYY-MM-DD"),
      first_name: firstname,
      last_name: lastname,
      dob: dob,
      gender: gandar,
      country_id: nationality,
      email: email,
      mobile_number: mobilenumber,
      address_line_first: address,
      address_line_second: address2,
      postal_code: Postalcode,
      niric_number: nricnumber,
      // race_number: racenumber,
      time: selecttime,
      contact_lang: languagesspoken,
      contact_home_no: Homenumber,
      contact_office_no: officenumber,
      family_member_name: Familyname,
      family_member_relation: relationshiptopatient,
      family_member_contact_no: Familynumber,
      family_member_hp: Familynumberhp,
      onset: onset,
      right: onsetR,
      left: onsetl,
      gradual: Gradual,
      student: Student,
      birth: birth,
      other_phase_state: otherphasestate,
      ear_pain: earpain,
      head_injury: headinjury,
      medical_condition: medicalcondition,
      discharge: discharge,
      surgery: surgery,
      current_medication: currentmedication,
      headache: headache,
      vomating: vomiting,
      noise_exposure: nosieexposure,
      sinusitus: sinusitus,
      pain_swallowing: painswallowing,
      family_history: familyhistory,
      vertigo: vertigo,
      fullness_of_ear: fullnessofear,
      tinnitus: tinnitus,
      one_to_one: onetoone,
      meeting: meeting,
      television: television,
      background_noise: backgroundnoise,
      group: group,
      church: church,
      telephone: telephone,
      other: other,
      remarks: remarks,
      referral_status: selectreferral,
      purpose_id: selecthearing,
    };
    dispatch(Appointmentbook(data)).then((res) => {
      if (res?.payload?.status == true) {
        toast.success(res?.payload?.message);
        handleClose();
        getAppointmentData();
        getviewuser();
        resetbtn();
        setRelationShiptoPatient("");
        setOfficeNumber("");
        setFamilyNumber("");
        setLanguagesSpoken("");
        setFamilyName("");
      } else {
        toast.error(res?.payload?.message);
        getAppointmentData();
      }
    });
  }
    // console.log("data", data);
  };

  const resetbtn = () => {
    setSelectTime();
  };
  const RemoveBookeddata = (id) => {
    setRemoveBook(id);
    setShowview2(true);
    setShowview(false);
  };

  const RemoveBooked = (id) => {
    // console.log(id, "id");

    const data = {
      id: id,
    };
    try {
      dispatch(RemoveAppointment(data)).then((res) => {
        if (res?.payload?.status === false) {
          // console.log(res?.payload?.data);
          closeViewPopup2();
          toast.error(res?.payload?.message);
          setShowview(false);
          // setTimeout(() => {
          //   getAppointmentData();
          // }, 1000);

          getAppointmentData();
        }
      });
    } catch (error) {
      console.log(error, "error");
      toast.error(error);
      getAppointmentData();
    }
  };

  const currentDay = new Date().getDay();

  // console.log("currentDay", currentDay);

  const [referralOptions, setReferralOptions] = useState([]);
  const [hearingOptions, setHearingOptions] = useState([]);
  const getreferralOptions = () => {
    try {
      dispatch(appointmentReferralOption()).then((res) => {
        if (res?.payload?.status === true) {
          setReferralOptions(res?.payload?.data);
        } else {
          setReferralOptions([]);
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  const getherOptions = () => {
    try {
      dispatch(appointmenthearOption()).then((res) => {
        if (res?.payload?.status === true) {
          setHearingOptions(res?.payload?.data);
        } else {
          setHearingOptions([]);
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  // const gettimeOptions = () => {
  //   console.log(creactdate, "ddf");
  //   const data = {
  //     date: moment(creactdate).format("YYYY-MM-DD"),
  //   };
  // };

  useEffect(() => {
    getreferralOptions();
    getherOptions();
  }, []);

  useEffect(() => {
    getAppointmentData();
  }, []);
  const [today, setToday] = useState("");
  useEffect(() => {
    const todayDate = new Date().toISOString().split("T")[0];
    setToday(todayDate);
  }, []);

  // Assuming 'creactdate' is the previous date you mentioned
  console.log("selectcenter", selectcenter);
  return (
    <>
      <div
        className="side_div_menu"
        style={{ display: "flex", height: "100%" }}
      >
        <Sidebarmenu />
        <section className="Home_page allsection">
          <TopHeader heding_text="Appointment" />
          <div className="Calender_section">
            <Calendar
              localizer={localizer}
              events={events4}
              startAccessor="start"
              selectable={true}
              endAccessor="end"
              components={components}
              eventPropGetter={eventStyleGetter}
              onSelectSlot={(slotInfo) => handleEventCreate(slotInfo)}
              onSelectEvent={handleEventCreate}
              style={{ height: "100vh" }}
              formats={formats}
              views={["month"]}
              toolbar={{
                date: false, // Show the date button
                today: true, // Show the today button
                next: true, // Show the next button
                prev: true, // Show the back (previous) button
              }} // Exclude 'week' and 'day' views
            />
          </div>
        </section>

        {/* add popup */}

        <Offcanvas
          className="offcanvas_popup"
          show={addmenuopen}
          onHide={handleClose}
          placement="end"
        >
          <button className="back_canvas" onClick={handleClose}>
            {" "}
            <img src={back} className="img-fluid" alt="first-img" />
          </button>
          <Offcanvas.Header>
            <Offcanvas.Title>
              Book Appointment
              <span>{moment(creactdate).format("DD/MM/YYYY")}</span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container p-0">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="Whatshap_text">
                      <a href="https://wa.me/6597767615" target="_blank">
                        <i class="fa fa-whatsapp" aria-hidden="true"></i>
                        &nbsp;&nbsp;
                        <span> Book Appointment on WhatsApp </span>
                      </a>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating">
                      <select
                        className="form-select"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={selectcenter}
                        onChange={handleChangecenter}
                      >
                        <option selected value="">Select Center</option>
                        {hearingcenter.map((country) => (
                          <option key={country.value} value={country.value}>
                            {country.label}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="floatingSelect">Select Center</label>
                    </div>
                     { (errorMessage && !selectcenter ) && <p className="text-danger" > Please select Center </p>  } 
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="FirstName"
                        placeholder="First Name"
                        value={firstname}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                      <label for="FirstName">First Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="LastName"
                        placeholder="Last Name"
                        value={lastname}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                      <label for="LastName">Last Name</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div class="form-floating">
                      <input
                        type="date"
                        className="form-control"
                        id="DateofBirth"
                        placeholder="MM/DD/YYYY"
                        value={dob}
                        onChange={handledate}
                        max={today}
                        pattern="\d{2}/\d{2}/\d{4}"
                      />
                      <label for="DateofBirth">Date of Birth</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="floatingSelect"
                        value={gandar}
                        aria-label="Floating label select example"
                        onChange={handleChangegender}
                      >
                        {/* <option selected>Select Center</option> */}
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="3">Other</option>
                      </select>
                      <label for="floatingSelect">Gander</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <select
                        className="form-select"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={nationality}
                        onChange={handleChangenationality}
                      >
                        {/* <option selected>Select Center</option> */}
                        {Countries.map((country) => (
                          <option key={country.value} value={country.value}>
                            {country.label}
                          </option>
                        ))}
                      </select>
                      <label htmlFor="floatingSelect">Nationality</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control"
                        id="EmailAddress"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <label for="EmailAddress">Email Address</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="AddressLine1 "
                        placeholder="Address Line1"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                      <label for="Address Line1">Address Line1</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="AddressLine2"
                        placeholder="Address Line2"
                        value={address2}
                        onChange={(e) => setAddress2(e.target.value)}
                      />
                      <label for="Address Line2">Address Line2</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="number"
                        className="form-control"
                        id="Postalcode"
                        placeholder="Postal code"
                        value={Postalcode}
                        onChange={(e) => setPostalcode(e.target.value)}
                      />
                      <label for="Postalcode">Postal code</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="NRICNumber"
                        placeholder="NRICNumber"
                        value={nricnumber}
                        onChange={(e) => setNRICNumber(e.target.value)}
                      />
                      <label for="NRICNumber">NRIC Number</label>
                    </div>
                  </div>

                  {/* <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="number"
                        className="form-control"
                        id="RaceNumber"
                        placeholder="RaceNumber"
                        value={racenumber}
                        onChange={(e) => setRaceNumber(e.target.value)}
                      />
                      <label for="RaceNumber">Race Number</label>
                    </div>
                  </div> */}

                  <div className="col-md-6">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={selecttime}
                        onChange={handleChangetime}
                      >
                        <option>Select Time</option>
                        {timeslot?.map((option, i) => (
                          <option
                            key={i}
                            value={option?.id}
                            disabled={option.is_disable}
                          >
                            {option?.title}
                          </option>
                        ))}

                        {/* {timeslot
                          ?.filter((option) => !option.is_disable)
                          .map((option, i) => (
                            <option key={i} value={option?.id}>
                              {option?.title}
                            </option>
                          ))} */}
                      </select>
                      <label for="floatingSelect">Clinic Time</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="floatingSelectdr"
                        aria-label="Floating label select example"
                        value={selectreferral}
                        onChange={handleReferral}
                      >
                        {referralOptions?.map((option, i) => (
                          <option key={i} value={option?.id}>
                            {option?.title}
                          </option>
                        ))}
                      </select>
                      <label for="floatingSelectdr">Referral Source</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="floatingSelectdr"
                        aria-label="Floating label select example"
                        value={selecthearing}
                        onChange={handleadjustment}
                      >
                        {hearingOptions?.map((option, i) => (
                          <option key={i} value={option?.id}>
                            {option?.title}
                          </option>
                        ))}
                      </select>
                      <label for="floatingSelectdr">Purpose Of Visit</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="number"
                        className="form-control"
                        id="Mobile/HPNoumber"
                        placeholder="Mobile/HP Number"
                        value={mobilenumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        required
                      />
                      <label for="Mobile/HPNoumber">Mobile/HP Number</label>
                    </div>
                  </div>
                  <h6 className="info_text">Contact Information</h6>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="LanguageSpoken"
                        placeholder="LanguageSpoken"
                        value={languagesspoken}
                        onChange={(e) => setLanguagesSpoken(e.target.value)}
                      />
                      <label for="LanguageSpoken">Language Spoken</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="number"
                        className="form-control"
                        id="HomeNumber"
                        placeholder="Home Number"
                        value={Homenumber}
                        onChange={(e) => setHomeNumber(e.target.value)}
                      />
                      <label for="HomeNumber">Home Number</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="number"
                        className="form-control"
                        id="OfficeNumber"
                        placeholder="Office Number"
                        value={officenumber}
                        onChange={(e) => setOfficeNumber(e.target.value)}
                      />
                      <label for="OfficeNumber">Office Number</label>
                    </div>
                  </div>

                  <h6 className="info_text">Other Family Members To Contact</h6>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="Name"
                        placeholder="Name"
                        value={Familyname}
                        onChange={(e) => setFamilyName(e.target.value)}
                      />
                      <label for="Name">Name</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="relationshiptopatient"
                        placeholder="Relationship to patient"
                        onChange={(e) =>
                          setRelationShiptoPatient(e.target.value)
                        }
                        value={relationshiptopatient}
                      />
                      <label for="relationshiptopatient">
                        Relationship to patient
                      </label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="number"
                        className="form-control"
                        id="ContactNumber"
                        placeholder="Contact Number"
                        onChange={(e) => setFamilyNumber(e.target.value)}
                        value={Familynumber}
                      />
                      <label for="ContactNumber">Contact Number</label>
                    </div>
                  </div>

                  {/* <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="number"
                        className="form-control"
                        id="HP"
                        placeholder="HP"
                        onChange={(e) => setFamilyNumberHp(e.target.value)}
                        value={Familynumberhp}
                      />
                      <label for="HP">HP</label>
                    </div>
                  </div> */}

                  {/* <h6 className="info_text">For Office USE</h6>
                  <p className="for_office">
                    Referral Source: From where did you find out about The{" "}
                    <span>Hearing Centre?</span>
                  </p> */}

                  {/* <div className="col-md-12">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={selectstate}
                        onChange={handleChangestate}
                      >
                       
                        <option value="1">MP</option>
                        <option value="2">MH</option>
                        <option value="3">UP</option>
                      </select>
                      <label for="floatingSelect">Please Select State</label>
                    </div>
                  </div> */}

                  {/* <h6 className="info_text">Complaint Of</h6>

                  <div className="col-md-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="Onset"
                        placeholder="Onset"
                        onChange={(e) => setOnSet(e.target.value)}
                        value={onset}
                      />
                      <label for="Onset">Onset</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="R"
                        placeholder="R"
                        onChange={(e) => setOnSetR(e.target.value)}
                        value={onsetR}
                      />
                      <label for="R">R</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="L"
                        placeholder="L"
                        onChange={(e) => setOnSetL(e.target.value)}
                        value={onsetl}
                      />
                      <label for="L">L</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="Gradual"
                        placeholder="Gradual"
                        onChange={(e) => setGradual(e.target.value)}
                        value={Gradual}
                      />
                      <label for="Gradual">Gradual</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="Student"
                        placeholder="Student"
                        onChange={(e) => setStudent(e.target.value)}
                        value={Student}
                      />
                      <label for="Student">Student</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="Birth"
                        placeholder="Birth"
                        onChange={(e) => setBirth(e.target.value)}
                        value={birth}
                      />
                      <label for="Birth">Birth</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="Other(Phase State)"
                        placeholder="Other(Phase State)"
                        onChange={(e) => setOtherPhaseState(e.target.value)}
                        value={otherphasestate}
                      />
                      <label for="Other(Phase State)">Other(Phase State)</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="EarPain"
                        placeholder="EarPain"
                        onChange={(e) => setEarPain(e.target.value)}
                        value={earpain}
                      />
                      <label for="EarPain">Ear Pain</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="HeadInjury"
                        placeholder="Head Injury"
                        onChange={(e) => setHeadInjury(e.target.value)}
                        value={headinjury}
                      />
                      <label for="HeadInjury">Head Injury</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="medicalcondition"
                        placeholder="Medical Condition"
                        onChange={(e) => setMedicalCondition(e.target.value)}
                        value={medicalcondition}
                      />
                      <label for="medicalcondition">Medical Condition</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="discharge"
                        placeholder="Discharge"
                        onChange={(e) => setDischarge(e.target.value)}
                        value={discharge}
                      />
                      <label for="discharge">Discharge</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="surgery"
                        placeholder="Surgery"
                        onChange={(e) => setSurgery(e.target.value)}
                        value={surgery}
                      />
                      <label for="surgery">Surgery</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="currentmedication"
                        placeholder="Current Medication"
                        onChange={(e) => setCurrentMedication(e.target.value)}
                        value={currentmedication}
                      />
                      <label for="currentmedication">Current Medication</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="headache"
                        placeholder="Headache"
                        onChange={(e) => setHeadache(e.target.value)}
                        value={headache}
                      />
                      <label for="headache">Headache</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="vomiting"
                        placeholder="Vomiting"
                        onChange={(e) => setVomiting(e.target.value)}
                        value={vomiting}
                      />
                      <label for="vomiting">Vomiting</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="nosieexposure"
                        placeholder="Nosie Exposure."
                        onChange={(e) => setNosieExposure(e.target.value)}
                        value={nosieexposure}
                      />
                      <label for="NosieExposure">Nosie Exposure.</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="sinusitus"
                        placeholder="Sinusitus"
                        onChange={(e) => setSinusitus(e.target.value)}
                        value={sinusitus}
                      />
                      <label for="sinusitus">Sinusitus</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="painswallowing"
                        placeholder="Pain Swallowing"
                        onChange={(e) => setPainSwallowing(e.target.value)}
                        value={painswallowing}
                      />
                      <label for="painswallowing">Pain Swallowing</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="familyhistory"
                        placeholder="Family History"
                        onChange={(e) => setFamilyHistory(e.target.value)}
                        value={familyhistory}
                      />
                      <label for="familyhistory">Family History </label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="vertigo"
                        placeholder="Vertigo"
                        onChange={(e) => setVertigo(e.target.value)}
                        value={vertigo}
                      />
                      <label for="vertigo">Vertigo</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="fullnessofear"
                        placeholder="Fullness of ear"
                        onChange={(e) => setFullnessOfEar(e.target.value)}
                        value={fullnessofear}
                      />
                      <label for="fullnessofear">Fullness of Ear</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="tinnitus"
                        placeholder="Tinnitus"
                        onChange={(e) => setTinnitus(e.target.value)}
                        value={tinnitus}
                      />
                      <label for="tinnitus">Tinnitus</label>
                    </div>
                  </div>

                  <h6 className="info_text">Area of Difficulty</h6>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="1to1"
                        placeholder="1 to 10"
                        onChange={(e) => setOneToOne(e.target.value)}
                        value={onetoone}
                      />
                      <label for="1to1">1 to 10 </label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="meeting"
                        placeholder="Meeting"
                        onChange={(e) => setMeeting(e.target.value)}
                        value={meeting}
                      />
                      <label for="meeting">Meeting</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="television"
                        placeholder="Television"
                        onChange={(e) => setTelevision(e.target.value)}
                        value={television}
                      />
                      <label for="television">Television</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="backgroundnoise"
                        placeholder="Background noise"
                        onChange={(e) => setBackgroundNoise(e.target.value)}
                        value={backgroundnoise}
                      />
                      <label for="backgroundnoise">Background noise</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="group"
                        placeholder="group"
                        onChange={(e) => setGroup(e.target.value)}
                        value={group}
                      />
                      <label for="group">group </label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="church"
                        placeholder="Church"
                        onChange={(e) => setChurch(e.target.value)}
                        value={church}
                      />
                      <label for="church">Church</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="telephone"
                        placeholder="Telephone"
                        onChange={(e) => setTelephone(e.target.value)}
                        value={telephone}
                      />
                      <label for="telephone">Telephone</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="other"
                        placeholder="Other"
                        onChange={(e) => setOther(e.target.value)}
                        value={other}
                      />
                      <label for="other">Other</label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div class="form-floating">
                      <textarea
                        class="form-control"
                        placeholder="Leave a Comment Here"
                        id="remarks"
                        rows="8"
                        style={{ height: "200px" }}
                        onChange={(e) => setRemarks(e.target.value)}
                        value={remarks}
                      ></textarea>
                      <label for="remarks">Remarks</label>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <button type="submit" className="btn Save_btn">
                      Book Appointment
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {/* View Modal */}

        <Modal
          isOpen={showview}
          onRequestClose={setShowview}
          style={customStyles}
          contentLabel="View Modal"
          id="View_popup"
        >
          <div className="popup_modal">
            <div className="modal_body">
              {eventview &&
                eventview.map((existingdata, index) => {
                  const currentDate = moment().startOf("day");
                  const previousDate = moment(eventview[0]?.start).startOf(
                    "day"
                  );
                  const isTodayOrFuture = moment(previousDate).isSameOrAfter(
                    currentDate,
                    "day"
                  );

                  // setRemoveBook(eventview.id);

                  return (
                    <>
                      <div className="Menu_view" key={index}>
                        <div className="d-flex align-items-center justify-content-between view_text">
                          <h6>
                            {" "}
                            Appointment Booked
                            {/* <span>
                              {moment(eventview[0]?.start).format("DD/MM/YYYY")}
                            </span> */}
                          </h6>
                          <div>
                            <button
                              className="closebtn"
                              onClick={() => RemoveBookeddata(existingdata.id)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                              >
                                <path
                                  d="M3.47748 19.1493C3.01584 19.1493 2.61556 18.9804 2.27663 18.6427C1.93769 18.3049 1.76823 17.906 1.76823 17.4461V3.29769H1.49323C1.25283 3.29769 1.05079 3.21543 0.887127 3.05092C0.723444 2.8864 0.641602 2.68332 0.641602 2.44167C0.641602 2.20003 0.723444 1.99842 0.887127 1.83682C1.05079 1.67522 1.25283 1.59442 1.49323 1.59442H5.60465C5.60465 1.34987 5.68649 1.14579 5.85018 0.982191C6.01384 0.818608 6.21588 0.736816 6.45628 0.736816H11.5443C11.7842 0.736816 11.9871 0.819775 12.1531 0.985691C12.319 1.15161 12.4019 1.35452 12.4019 1.59442H16.5074C16.7478 1.59442 16.9498 1.67668 17.1135 1.84122C17.2772 2.00573 17.359 2.20881 17.359 2.45044C17.359 2.69209 17.2772 2.89371 17.1135 3.05529C16.9498 3.21689 16.7478 3.29769 16.5074 3.29769H16.2324V17.4461C16.2324 17.906 16.0629 18.3049 15.724 18.6427C15.385 18.9804 14.9848 19.1493 14.5231 19.1493H3.47748ZM3.47748 3.29769V17.4461H14.5231V3.29769H3.47748ZM6.09758 14.5461C6.09758 14.7694 6.17524 14.9582 6.33058 15.1125C6.48589 15.2668 6.67602 15.3439 6.90095 15.3439C7.12589 15.3439 7.31516 15.2668 7.46878 15.1125C7.62241 14.9582 7.69923 14.7694 7.69923 14.5461V6.17269C7.69923 5.94932 7.62057 5.75952 7.46325 5.60327C7.30594 5.44702 7.11481 5.36889 6.88988 5.36889C6.66494 5.36889 6.47666 5.44702 6.32503 5.60327C6.17339 5.75952 6.09758 5.94932 6.09758 6.17269V14.5461ZM10.3014 14.5461C10.3014 14.7694 10.38 14.9582 10.5374 15.1125C10.6947 15.2668 10.8858 15.3439 11.1107 15.3439C11.3357 15.3439 11.5249 15.2668 11.6786 15.1125C11.8322 14.9582 11.909 14.7694 11.909 14.5461V6.17269C11.909 5.94932 11.8309 5.75952 11.6748 5.60327C11.5187 5.44702 11.3276 5.36889 11.1014 5.36889C10.8753 5.36889 10.6854 5.44702 10.5318 5.60327C10.3782 5.75952 10.3014 5.94932 10.3014 6.17269V14.5461Z"
                                  fill="#777391"
                                ></path>
                              </svg>
                            </button>
                            &nbsp;&nbsp;
                            <button
                              className="closebtn"
                              onClick={closeViewPopup}
                            >
                              {/* <img
                              src={backimg}
                              className="img-fluid"
                              alt="bacK-img"
                            /> */}

                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <circle cx="12" cy="12" r="12" fill="#F7A3B2" />
                                <path
                                  d="M8 17L7 16L11 12L7 8L8 7L12 11L16 7L17 8L13 12L17 16L16 17L12 13L8 17Z"
                                  fill="#F8F9FA"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>

                        <div className="modal-body">
                          <div className="hearing_center mb-0">
                            <h4>Appointment-Number</h4>
                            <h5>{existingdata?.appointmentnumber}</h5>
                          </div>

                          <div className="hearing_center">
                            <h4>Hearing Centre</h4>
                            <h5>{existingdata.title}</h5>

                            <h4>Appointment Date & Time </h4>
                            <h3>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                              >
                                <path
                                  d="M5.9625 12.2625L3.3 9.6L4.3875 8.5125L5.9625 10.0875L9.1125 6.9375L10.2 8.025L5.9625 12.2625ZM1.5 15C1.0875 15 0.734375 14.8531 0.440625 14.5594C0.146875 14.2656 0 13.9125 0 13.5V3C0 2.5875 0.146875 2.23438 0.440625 1.94063C0.734375 1.64688 1.0875 1.5 1.5 1.5H2.25V0H3.75V1.5H9.75V0H11.25V1.5H12C12.4125 1.5 12.7656 1.64688 13.0594 1.94063C13.3531 2.23438 13.5 2.5875 13.5 3V13.5C13.5 13.9125 13.3531 14.2656 13.0594 14.5594C12.7656 14.8531 12.4125 15 12 15H1.5ZM1.5 13.5H12V6H1.5V13.5ZM1.5 4.5H12V3H1.5V4.5Z"
                                  fill="#737373"
                                />
                              </svg>{" "}
                              &nbsp;&nbsp;{" "}
                              {moment(existingdata?.start).format("DD/MM/YYYY")}
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                              >
                                <path
                                  d="M9.975 11.025L11.025 9.975L8.25 7.2V3.75H6.75V7.8L9.975 11.025ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4813 2.19375 12.8063C1.51875 12.1313 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1313 1.51875 12.8063 2.19375C13.4813 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4813 12.1313 12.8063 12.8063C12.1313 13.4813 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15ZM7.5 13.5C9.1625 13.5 10.5781 12.9156 11.7469 11.7469C12.9156 10.5781 13.5 9.1625 13.5 7.5C13.5 5.8375 12.9156 4.42188 11.7469 3.25313C10.5781 2.08438 9.1625 1.5 7.5 1.5C5.8375 1.5 4.42188 2.08438 3.25313 3.25313C2.08438 4.42188 1.5 5.8375 1.5 7.5C1.5 9.1625 2.08438 10.5781 3.25313 11.7469C4.42188 12.9156 5.8375 13.5 7.5 13.5Z"
                                  fill="#737373"
                                />
                              </svg>{" "}
                              &nbsp;&nbsp;{existingdata?.timezone}{" "}
                            </h3>
                          </div>

                          <div className="hearing_center">
                            <h4>Doctor</h4>
                            <h5>Dr.{existingdata?.audiologistname}</h5>
                          </div>

                          <div className="hearing_center">
                            <h4>Address</h4>
                            <h5>{existingdata?.branchaddress}</h5>
                          </div>

                          <div className="hearing_center">
                            <h4>Purpose Of Visit</h4>
                            <h5>{existingdata?.purposeOfVisit}</h5>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          </div>
        </Modal>

        {/* deleted popup */}

        <Modal
          isOpen={showview2}
          onRequestClose={setShowview2}
          style={customStyles}
          contentLabel="View Modal"
          id="View_popup2"
        >
          <div className="popup_modal">
            <div className="modal_body">
              <div className="Menu_view">
                <div className="d-flex align-items-center justify-content-center view_text">
                  <h6>
                    {" "}
                    Do you want to delete this appointment ?
                    {/* <span>
                              {moment(eventview[0]?.start).format("DD/MM/YYYY")}
                            </span> */}
                  </h6>
                </div>

                <div className="modal-body">
                  <div className="Remove_booked">
                    <button
                      className="btn"
                      onClick={() => RemoveBooked(removebook)}
                    >
                      Yes
                    </button>
                    <button className="btn" onClick={() => closeViewPopup2()}>
                      NO
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default CalendarPage;
